import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Helmet from 'react-helmet';
import CabModifySearch from '../../components/CabModifySearch/CabModifySearch';
import WhyBookWithUs from '../../components/WhyBookWithUs/WhyBookWithUs';
import FaqSection from '../../components/Faq/Faq';
import TopCarTypeCabsRoutes from '../../components/TopCarTypeCabRoutes/TopCarTypeCabRoutes';
import TopCabsRoutes from '../../components/TopCabsRoutes/TopCabsRoutes';
import Footer from '../../components/Footer/Footer';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import PageHeader from '../../components/PageHeader/PageHeader';
import { trackRouteCarTypeTemplateEvent } from '../../utils/omnitureTracking';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import AppContextProvider from '../../AppContext';
import ThingsToKnow from '../../components/ThingsToKnow/ThingsToKnow';
import { ThrowReporter } from 'io-ts/lib/ThrowReporter';
import { PathReporter } from 'io-ts/lib/PathReporter';
import '../CityOperatorTemplate/CityOperatorTemplate.css';
import { EnvironmentVariables } from '../../types';
import { getAppEnv } from '../../../config/env';
import Overlay from '../../components/BPG/Overlay';
import { useKnowMoreDetails } from '../customHooks';
import '../MultiCityPage/MultiCityPage.css';
import {
  detectUserActivity,
  generateRequestId,
  isMobile,
  isSEM,
  useSearchWidgetHooks
} from '../../utils/commonUtils';
import {
  RouteCarTypeTemplateData,
  RouteCarTypeTemplateChecker
} from './RouteCarTypeDataTypeChecker';
import { RouteComponentProps } from 'react-router';
import CompactList from '../../components/CompactList/CompactList';
import RouteCarTypeCabs from '../../components/RouteCarTypeCabs/RouteCarTypeCabs';
import AdsComponent from '../../components/adsComponent';
import './RouteCarTypeTemplate.css';
import { SEO_ROUTE_CARTYPE_TEMPLATE } from '../../constants/templateConstants';
import { yeildToMainThread } from '../../scheduler';
import ProductSchema from '../../utils/ProductSchema';
import { SCROLL } from '../../constants/miscellaneousConstants';
import { makeServiceDeskRequest } from '../../cabsAPIs';
import AssistModal from '../../components/AssistModal';
import CallUsModal from '../../components/AssistModal/callUsModal';
import InboundCallBox from '../../components/InboundCall/InboundCallBox';
import TripAssistant from '../TripAssistant';
import PackagesBottomSheet from '../../components/GenerateBanner/PackagesBottomSheet';
import PackagesModal from '../../components/PackagesModal/PackagesModal';
import PackageBanner from '../../components/PackageBanner/PackageBanner';
const env = getAppEnv();
const { DATA_LOADER_URL, PUBLIC_URL } = env.raw as EnvironmentVariables;
const isSSR = typeof window === 'undefined';
const ASSISTED_FORM_DATA_LS = 'ASSISTED_FORM_DATA_LS';

type PathParamsType = {
  routeCarTypeId: string;
};
type RouteCarTypeTemplateProp = RouteComponentProps<PathParamsType> & {
  data: RouteCarTypeTemplateData;
};

const runtimeTypChecker = (data: RouteCarTypeTemplateData) => {
  const result = RouteCarTypeTemplateChecker.decode(data);
  if (result._tag !== 'Right') {
    console.log(PathReporter.report(result));
    ThrowReporter.report(result);
  }
};
const RouteTemplate = ({ data }: RouteCarTypeTemplateProp) => {
  // runtimeTypChecker(data);
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const [
    selectedKnowMoreDetailsForMobile,
    setSelectedKnowMoreDetailsForMobile
  ] = useKnowMoreDetails(null, isMobileDevice);
  const delayedKnowMoreDetailsForMobile = async val => {
    await yeildToMainThread(() => setSelectedKnowMoreDetailsForMobile(val));
  };

  const [showAssistantIc, setShowAssistantIc] = useState(false);
  const [showWhatsAppIcon, setWhatsAppIcon] = useState(false);
  const [showCallUsIcon, setCallUsIcon] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const scrollPosition = useRef(0);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [shouldShowPackages, setShouldShowPackages] = useState(false);
  const assistedFormLifeCycle = useRef(0); // 0:init,1:scroll down to threshold, 2: scroll up to threshold, and automated modal shown

  const userActionDone = () => {
    return window?.localStorage?.getItem('userActionDone') == 'true';
  };

  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const toggleOverlay = (isVisible: boolean) => {
    setIsOverlayVisible(isVisible);
  };
  const setShowModalWithDelay = async val => {
    if (isMobile() && (showCallusModalMweb || showTripAssistantButton)) {
      await yeildToMainThread(() =>
        requestAnimationFrame(() => setShowModal(val))
      );
    }
  };
  const showModalConsideringScrollEvents = () => {
    if (assistedFormLifeCycle.current != 2 && !userActionDone()) {
      assistedFormLifeCycle.current = 2;
      setShowModalWithDelay(true);
      const eventName =
        showCallusModalMweb && showCallUsForAssistedForm && isMobile()
          ? 'Cab_SEO_Assisted_Call_Us_Form_Shown'
          : 'Cab_SEO_Assisted_Form_Shown';
      trackRouteCarTypeTemplateEvent(eventName);
    }
  };

  useEffect(() => {
    //
    const handleScroll = () => {
      scrollPosition.current = window.scrollY || window.pageYOffset;

      const scrollDownThreshold = isMobileDevice ? 500 : 900;
      const scrollUpThreshold = scrollDownThreshold - 100;

      if (
        scrollPosition.current > scrollDownThreshold &&
        assistedFormLifeCycle.current == 0
      ) {
        assistedFormLifeCycle.current = 1;
      } else if (
        scrollPosition.current < scrollUpThreshold &&
        assistedFormLifeCycle.current == 1
      ) {
        showModalConsideringScrollEvents();
      }
    };

    // If tripAssistantOpen is true in the query params then open form
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('tripAssistantOpen') === 'true') {
      showModalConsideringScrollEvents();
    }

    // Attach the scroll event listener
    window.addEventListener(SCROLL, handleScroll);
    if (window?.localStorage) {
      localStorage.removeItem(ASSISTED_FORM_DATA_LS);
    }

    openFormDueToInactivity();
    if (showCallUsWidget && isMobile()) {
      setTimeout(() => {
        trackRouteCarTypeTemplateEvent('Cab_SEO_Call_Us_Icon_Shown');
      }, 500);
    }

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener(SCROLL, handleScroll);
    };
  }, []);

  const openFormDueToInactivity = () => {
    const timeDelay = showCallusModalMweb
      ? callusModalOpenDelay
      : assistedFormOpenDelay;
    setTimeout(() => {
      if (window?.localStorage && assistedFormLifeCycle.current != 2) {
        if (
          !userActionDone() &&
          (isMobile()
            ? showTripAssistantButton || showCallusModalMweb
            : showTripAssistantButtonForDweb)
        ) {
          showModalConsideringScrollEvents();
        } else {
          // not show message should not be shown if modal is already shown
          const userAction = userActionDone();
          trackRouteCarTypeTemplateEvent(
            `Cab_SEO_Assisted_Form_Not_Shown_userActionDone_${userAction}`
          );
        }
      }
    }, timeDelay);
  };

  useEffect(() => {
    window.addEventListener(SCROLL, listenToScroll);
    detectUserActivity();
    return () => window.removeEventListener(SCROLL, listenToScroll);
  }, []);

  const listenToScroll = () => {
    const heightToShowFrom = 100;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToShowFrom) {
      if (!(isMobileDevice && showModal)) {
        setShowAssistantIc(true);
        setWhatsAppIcon(true);
        setCallUsIcon(true);
      }
    } else {
      setShowAssistantIc(false);
      setWhatsAppIcon(false);
      setCallUsIcon(false);
    }
  };

  const fabInteraction = () => {
    return (
      <div
        className={` ${(() => {
          if (showTripAssistantButtonForDweb && showTripAssistantButton) {
            return '';
          } else if (showTripAssistantButton) {
            return 'mobileShow';
          } else if (showTripAssistantButtonForDweb) {
            return 'desktopShow';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackRouteCarTypeTemplateEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`fabInteraction ${
            showModal && isMobileDevice
              ? 'showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
          {true && <span>Trip Assistant</span>}
        </div>
      </div>
    );
  };

  const callUsForm = () => {
    return (
      <div
        className={` ${(() => {
          if (showCallusModalMweb) {
            return '';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackRouteCarTypeTemplateEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Call_Us_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`${
            showModal && isMobileDevice
              ? 'fabInteraction showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
        </div>
      </div>
    );
  };

  const onWhatsAppIconClick = () => {
    const requestId = generateRequestId();
    const pageName = 'seo_route_car_type_page';
    makeServiceDeskRequest(requestId, pageName);
    const whatsAppChatLinkWithRequestId = whatsappWidgetDeeplink
      ? whatsappWidgetDeeplink.replace('MDRequest_id', requestId)
      : '';
    if (whatsAppChatLinkWithRequestId)
      window.location.href = whatsAppChatLinkWithRequestId;
  };

  const onCallUsIconClick = () => {
    window.open(`tel:${customerCareNumberFinal}`, '_blank');
  };

  const {
    routeData,
    topRoutesfromCity,
    topRoutesToCity,
    templateData,
    description,
    otherRoutesFromSource,
    otherRoutesToDestination,
    nearbyCities,
    otherCarTypeRouteCabs,
    carTypeRouteCabs,
    routeCabInfo,
    carTypeInfo,
    carTypeData,
    hrPackages,
    interlinks,
    aggregateRating,
    schemaMinFare,
    assistedFormOpenDelay = 10000,
    showTripAssistantButton = true,
    showTripAssistantButtonForDweb = true,
    showWhatsappWidget = true,
    whatsappWidgetDeeplink = 'https://wa.me/919951106499?text=Request%20ID%20MDRequest_id%20%0AHi,%20I%20am%20looking%20for%20a%20cab%20from%20Delhi%20to%20Agra',
    customerCareNumber = '01244781861',
    assistantWidgetText = 'You can Call Us or Chat via WhatsApp',
    showWhatsAppForAssistedForm = true,
    semCustomerCareNumber = '',
    semInboundCallNumber = '',
    showCallUsWidget = false,
    showCallUsForAssistedForm = true,
    inboundCallText = 'Talk to agent (24x7)',
    inboundCallNumber = '0124 - 4781861',
    showInboundCallNumberInDesktop = true,
    showCallusModalMweb = false,
    callusModalOpenDelay = 10000,
    showInboundNumberOnAssistedForm = true,
    couponInfo = null,
    showLeaveIntentForm = false,
    packageData,
    whatsappTooltipText,
    tripAssistanceToolTipText,
    openTripTypeAndThenDate,
    openDateWidget,
    openTripType
  } = data;

  let inboundCallNumberFinal = inboundCallNumber;
  let customerCareNumberFinal = customerCareNumber;
  if (isSEM()) {
    inboundCallNumberFinal = semInboundCallNumber;
    customerCareNumberFinal = semCustomerCareNumber;
  }
  const { name } = carTypeData;
  const carTypeName = name;
  const { sourceCityData, destinationCityData } = routeData;

  const {
    name: sourceCityName,
    code: sourceCityCode,
    description: sourceCityDescription
  } = sourceCityData;

  const {
    name: destinationCityName,
    code: destinationCityCode
    // description: destinationCityDescription
  } = destinationCityData;

  const { travelFor, pickUpTime, dropTime } = useSearchWidgetHooks(
    SEO_ROUTE_CARTYPE_TEMPLATE
  );

  const [showWhatsAppTooltip, setShowWhatsAppTooltip] = useState(
    Boolean(whatsappTooltipText)
  );
  const [showTripAssistantTooltip, setShowTripAssistantTooltip] = useState(
    Boolean(tripAssistanceToolTipText)
  );

  const tooltipDelay = packageData?.tooltipInfo?.delay || 3000;

  useEffect(() => {
    if (showWhatsAppTooltip) {
      setTimeout(() => {
        setShowWhatsAppTooltip(false);
      }, tooltipDelay);
    }
    if (showTripAssistantTooltip) {
      setTimeout(() => {
        setShowTripAssistantTooltip(false);
      }, tooltipDelay);
    }
  });

  const handleClose = () => {
    setIsBottomSheetOpen(false);
    // logRttEventLogger({omniUrlArgs:`source=${
    //     isomorph ? SEO_ROUTE_TEMPLATE_ISOMORPHIC : SEO_ROUTE_TEMPLATE
    //   }`, eventName: 'Cab_Packages_Bottom_Sheet_Closed', pageUrl: templateData.sampleUrl });

    trackRouteCarTypeTemplateEvent('Cab_Packages_Bottom_Sheet_Closed');
  };
  useEffect(() => {
    if (packageData && packageData?.show_delay) {
      const timer = setTimeout(() => {
        // const ModalOrSheetOpened = window.sessionStorage.getItem(
        //   'packageModalOrSheetOpenedRoute'
        // );
        // if (!ModalOrSheetOpened) {
        if (isMobile()) {
          // logRttEventLogger({omniUrlArgs:`source=${
          //   isomorph ? SEO_ROUTE_TEMPLATE_ISOMORPHIC : SEO_ROUTE_TEMPLATE
          // }`, eventName: 'Cab_Packages_Bottom_Sheet_Shown',pageUrl:templateData.sampleUrl });

          trackRouteCarTypeTemplateEvent('Cab_Packages_Bottom_Sheet_Shown');
          setIsBottomSheetOpen(packageData.show_bottom_sheet_mweb);
        } else {
          //      logRttEventLogger({omniUrlArgs:`source=${
          //   isomorph ? SEO_ROUTE_TEMPLATE_ISOMORPHIC : SEO_ROUTE_TEMPLATE
          // }`, eventName: 'Cab_Packages_Modal_Shown',pageUrl:templateData.sampleUrl });

          trackRouteCarTypeTemplateEvent('Cab_Packages_Modal_Shown');
          setShouldShowPackages(packageData.show_modal_dweb);
        }
        //   window.sessionStorage.setItem(
        //     'packageModalOrSheetOpenedRoute',
        //     'true'
        //   );
        // }
      }, packageData.show_delay);

      return () => clearTimeout(timer);
    }
  }, [packageData]);

  const handleTooltipClose = e => {
    e.stopPropagation();
    setShowWhatsAppTooltip(false);
  };

  const handleWhatsappWidget = () => {
    onWhatsAppIconClick();
    trackRouteCarTypeTemplateEvent('Cab_SEO_WhatsApp_Assisted_Icon_Clicked');
    setShowWhatsAppTooltip(false);
  };

  return (
    <AppContextProvider
      omniUrlArgs={`source=${SEO_ROUTE_CARTYPE_TEMPLATE}`}
      trackTemplateEvent={trackRouteCarTypeTemplateEvent}
      selectedKnowMoreDetailsForMobile={selectedKnowMoreDetailsForMobile}
      setSelectedKnowMoreDetailsForMobile={delayedKnowMoreDetailsForMobile}
    >
      <div>
        {isMobile() && showWhatsappWidget && (
          <div className="whatsapp-wrapper">
            {showWhatsAppTooltip && (
              <div className="whatsapp-tooltip">
                <span className="whatsapp-tooltip-text">
                  {packageData?.tooltipInfo?.text || 'Chat with us on WhatsApp'}
                </span>
                <img
                  onClick={handleTooltipClose}
                  src={`${PUBLIC_URL}/static/public/cross_white_icon.png`}
                  alt="close"
                  className="whatsapp-tooltip-close"
                />
              </div>
            )}
            <div
              className={`${!showModal ? 'whatsApp' : ''} ${
                showModal ? '' : showWhatsAppIcon ? 'showWhatsAppIcon' : ''
              }`}
              onClick={handleWhatsappWidget}
            >
              <div
                className={`${!showModal ? 'whatsaAppIconContainer' : ''}`}
              />
              {true && !showModal && <span>Chat with us</span>}
            </div>
          </div>
        )}
      </div>
      <div>
        {isMobile() && showCallUsWidget && customerCareNumberFinal && (
          <div
            className={`${!showModal ? 'callUs' : ''} ${
              showModal ? '' : showCallUsIcon ? 'showCallUsIcon' : ''
            }`}
            onClick={() => {
              onCallUsIconClick();
              trackRouteCarTypeTemplateEvent('Cab_SEO_Call_Us_Icon_Clicked');
            }}
          >
            <div className={`${!showModal ? 'callUsIconContainer' : ''}`} />
            {true && !showModal && <span>Call us now</span>}
          </div>
        )}
      </div>
      {isMobile() && showTripAssistantButton ? fabInteraction() : <div></div>}
      {(showTripAssistantButtonForDweb || showLeaveIntentForm) &&
      !isMobile() ? (
        <div className="tripAssistant">
          {showTripAssistantTooltip && (
            <div className="tripassistant-tooltip">
              <span className="tripassistant-tooltip-text">
                {packageData?.tooltipInfo?.text}
              </span>
              <img
                onClick={e => {
                  e.stopPropagation();
                  setShowTripAssistantTooltip(false);
                }}
                src={`${PUBLIC_URL}/static/public/cross_white_icon.png`}
                alt="close"
                className="tripassistant-tooltip-close"
              />
            </div>
          )}
        </div>
      ) : (
        <div className="tripAssistant"></div>
      )}
      {(showTripAssistantButtonForDweb || showLeaveIntentForm) &&
      !isMobile() ? (
        <div className="tripAssistant2">
          <TripAssistant
            customerCareNumber={inboundCallNumberFinal}
            trackEvent={trackRouteCarTypeTemplateEvent}
            source={sourceCityName}
            autoOpenDelay={assistedFormOpenDelay}
            couponData={couponInfo}
            showTripAssistant={showTripAssistantButtonForDweb}
            showLeaveIntentForm={showLeaveIntentForm}
          />
        </div>
      ) : (
        <div className="tripAssistant2"></div>
      )}
      {showCallusModalMweb && callUsForm()}
      {showModal && isMobile() && showTripAssistantButton && (
        <AssistModal
          sourceCity={sourceCityName}
          setShowModal={val => setShowModalWithDelay(val)}
          trackTemplateEvent={trackRouteCarTypeTemplateEvent}
          showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
          showCallUsForAssistedForm={showCallUsForAssistedForm}
          customerCareNumber={customerCareNumberFinal}
          assistantWidgetText={assistantWidgetText}
          onCallUsIconClick={onCallUsIconClick}
          onWhatsAppIconClick={onWhatsAppIconClick}
          showInboundNumberOnAssistedForm={showInboundNumberOnAssistedForm}
          inboundCallNumber={inboundCallNumberFinal}
          inboundCallText={inboundCallText}
          destinationCity={destinationCityName}
        />
      )}
      {showModal && isMobile() && showCallusModalMweb && (
        <CallUsModal
          setShowModal={val => setShowModalWithDelay(val)}
          trackTemplateEvent={trackRouteCarTypeTemplateEvent}
          showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
          showCallUsForAssistedForm={showCallUsForAssistedForm}
          customerCareNumber={customerCareNumberFinal}
          assistantWidgetText={assistantWidgetText}
          onCallUsIconClick={onCallUsIconClick}
          onWhatsAppIconClick={onWhatsAppIconClick}
          showModal={showModal}
        />
      )}
      {packageData && isMobile() && isBottomSheetOpen && !userActionDone() ? (
        <PackagesBottomSheet
          packageData={packageData}
          onClose={handleClose}
          pageUrl={templateData.sampleUrl}
        />
      ) : null}
      {packageData && !isMobile() && shouldShowPackages && !userActionDone() && (
        <PackagesModal
          pageUrl={templateData.sampleUrl}
          packageData={packageData}
          onClose={() => {
            setShouldShowPackages(false);
            // logRttEventLogger({omniUrlArgs:`source=${
            //   isomorph ? SEO_ROUTE_TEMPLATE_ISOMORPHIC : SEO_ROUTE_TEMPLATE
            // }`, eventName: 'Cab_Packages_Modal_Closed', pageUrl: templateData.sampleUrl });

            trackRouteCarTypeTemplateEvent('Cab_Packages_Modal_Closed');
          }}
          show={true}
        />
      )}
      <div
        className={`cabSeoDtPage ${
          selectedKnowMoreDetailsForMobile ? 'expanded' : ''
        }`}
      >
        <Helmet>
          <title>{templateData.metaTitle}</title>
          <meta name="description" content={templateData.metaDescription} />
          <meta name="keywords" content={templateData.metaKeywords} />
          <link rel="canonical" href={templateData.sampleUrl} />
        </Helmet>
        {aggregateRating && (
          <ProductSchema
            data={aggregateRating}
            templateData={templateData}
            schemaMinFare={schemaMinFare}
            source={sourceCityName}
            dest={destinationCityName}
          />
        )}
        <div className={`desktopShow makeSticky`}>
          <CabModifySearch
            openDateWidget={openDateWidget}
            openTripType={openTripType}
            openTripTypeAndThenDate={openTripTypeAndThenDate}
            pickupTime={pickUpTime}
            defaultTripType={travelFor}
            returnTime={dropTime}
            returnCloseFlagDefault={false}
            sourceCityCode={sourceCityCode}
            destinationCityCode={destinationCityCode}
            sourceCityName={sourceCityName}
            destinationCityName={destinationCityName}
            isMobileDevice={false}
            hrPackages={hrPackages}
            title={`${sourceCityName} to ${destinationCityName} Cabs`}
          />
        </div>

        <div className={`domChanger mobileShow makeSticky`}>
          <CabModifySearch
            isOverlayVisible={isOverlayVisible}
            overlayToggle={toggleOverlay}
            openDateWidget={openDateWidget}
            openTripType={openTripType}
            openTripTypeAndThenDate={openTripTypeAndThenDate}
            pickupTime={pickUpTime}
            defaultTripType={travelFor}
            returnTime={dropTime}
            returnCloseFlagDefault={false}
            sourceCityCode={sourceCityCode}
            destinationCityCode={destinationCityCode}
            sourceCityName={sourceCityName}
            destinationCityName={destinationCityName}
            isMobileDevice={true}
            hrPackages={hrPackages}
            title={`${sourceCityName} to ${destinationCityName} Cabs`}
          />
        </div>
        <main className="container">
          <div className="makeFlex">
            <BreadCrumb breadcrumb={templateData.breadcrumb} />
            {showInboundCallNumberInDesktop ? (
              <InboundCallBox
                inboundCallText={inboundCallText}
                inboundCallNumber={inboundCallNumberFinal}
              />
            ) : (
              <div></div>
            )}
          </div>
          <PageHeader
            title={templateData.h1Title}
            extraInfo={templateData.extraInfo}
            isMobileDevice={isMobileDevice}
          />
          {packageData && (
            <PackageBanner
              packageData={packageData}
              pageUrl={templateData.sampleUrl}
            />
          )}
          {carTypeRouteCabs.length > 0 && routeCabInfo && (
            <>
              <div>
                <h2 className={`routeCarTypeCabsHeading`}>
                  {`${sourceCityName} to ${destinationCityName} ${carTypeName} Cabs |
                One Way Distance ${routeCabInfo['oneWayDistance']} | One Way Duration ${routeCabInfo['oneWayDurationInHrMins']} `}
                </h2>
                <div id={`carTypeRouteCars`}>
                  <RouteCarTypeCabs
                    data={carTypeRouteCabs}
                    carTypeName={carTypeName}
                    sourceCityName={sourceCityName}
                    destinationCityName={destinationCityName}
                    carTypeInfo={carTypeInfo}
                    seoUrl={''}
                    noOfListings={10}
                  />
                </div>
              </div>
              <br />
            </>
          )}
          <div>
            {templateData?.usps?.length > 0 && (
              <section className="bookWithUsWrap">
                <h2>
                  {isMobileDevice
                    ? `Why Book  with Us`
                    : `Why to Book ${sourceCityName} to ${destinationCityName} Cabs with Us`}
                </h2>
                <WhyBookWithUs usps={templateData.usps} />
              </section>
            )}
          </div>
          {otherCarTypeRouteCabs.cabTypes.length > 0 && (
            <TopCabsRoutes
              h2={`Other Cab Options from ${sourceCityName} to ${destinationCityName}`}
              cityName={sourceCityName}
              routeType="From"
              carTypeName={carTypeName}
              data={otherCarTypeRouteCabs}
            />
          )}
          {topRoutesfromCity.length > 0 && (
            <>
              <section>
                <h2>{`Top ${carTypeName} Cab Routes from ${sourceCityName}`}</h2>
                <TopCarTypeCabsRoutes
                  cityName={sourceCityName}
                  routeType="From"
                  data={topRoutesfromCity}
                  carTypeName={carTypeName}
                />
              </section>
              <br />
            </>
          )}
          {topRoutesToCity.length > 0 && (
            <>
              <section>
                <h2>{`Top ${carTypeName} Cab Routes to ${destinationCityName}`}</h2>
                <TopCarTypeCabsRoutes
                  cityName={destinationCityName}
                  routeType="To"
                  data={topRoutesToCity}
                  carTypeName={carTypeName}
                />
              </section>
              <br />
            </>
          )}
          {/* {mySafetyHtmls.ePassUsp && (
            <div className=" appendBottom40">
              <EpassBnr html={mySafetyHtmls.ePassUsp} />
            </div>
          )} */}
          {/* <br style={{ display: 'none' }} />
          {mySafetyHtmls.stateGuidelines && (
            <section>
              <h2>State Guidelines for e-Passes</h2>
              <StateGuidelines html={mySafetyHtmls.stateGuidelines} />
            </section>
          )} */}
          <div
            style={{ flexWrap: 'wrap' }}
            className={`cabsSeoWrap__Details makeFlex visibilityAuto`}
          >
            {interlinks &&
              interlinks.map(({ title, links }) => {
                return (
                  <CompactList
                    titlePrefix={title}
                    titleSuffix={``}
                    list={links}
                    type={'bullets'}
                    className={'rightMargin'}
                  >
                    {(item: any, idx, style) => (
                      <li
                        key={`${item.text}_${idx}`}
                        className={`${
                          idx ? `paddingT10 paddingB10` : `paddingB10`
                        }`}
                      >
                        {item.url ? (
                          <a
                            className={`linkBoxFont `}
                            onClick={() => {
                              //TO DO: add omniture events from Dataloader
                            }}
                            href={item.url}
                          >
                            {item.text}
                          </a>
                        ) : (
                          <span>{item.text}</span>
                        )}
                      </li>
                    )}
                  </CompactList>
                );
              })}
          </div>
          {templateData.faq.length > 0 && (
            <section className="visibilityAuto">
              <h2>{`Frequently Asked Questions for ${sourceCityName} to ${destinationCityName} ${carTypeName} Cab Booking`}</h2>
              <FaqSection
                trackTemplateEvent={trackRouteCarTypeTemplateEvent}
                data={templateData.faq}
                fromCityCode={sourceCityCode}
                toCityCode={destinationCityCode}
                pageUrl={templateData.sampleUrl}
              />
            </section>
          )}
          {description && (
            <section className="visibilityAuto">
              <h2>{`${sourceCityName} to ${destinationCityName} Cab Booking on MMT`}</h2>
              <ThingsToKnow html={description} />
            </section>
          )}
          {/* {(sourceCityDescription || destinationCityDescription) && (
            <section>
              <h2>
                {`Things To Know About 
              ${(() => {
                if (sourceCityDescription && destinationCityDescription) {
                  return `${sourceCityName} and ${destinationCityName}`;
                } else if (sourceCityDescription) {
                  return `${sourceCityName}`;
                } else if (destinationCityDescription) {
                  return `${destinationCityName}`;
                }
              })()}`}
              </h2>
              <ThingsToKnow
                text1={sourceCityDescription ? sourceCityDescription : ''}
                text2={
                  destinationCityDescription ? destinationCityDescription : ''
                }
              />
            </section>
          )} */}
        </main>
        {selectedKnowMoreDetailsForMobile ? (
          <Overlay
            cancelButton={() => delayedKnowMoreDetailsForMobile(null)}
            knowMoreDetails={selectedKnowMoreDetailsForMobile}
          />
        ) : null}
        <Footer template={templateData} />
        <div
          className="blackOverlay"
          onClick={() => {
            delayedKnowMoreDetailsForMobile(null);
          }}
        ></div>
        {isOverlayVisible && (
          <div
            onClick={() => {
              toggleOverlay(false);
            }}
            className="searchWidgetModal mobileShow"
          ></div>
        )}
      </div>
    </AppContextProvider>
  );
};

RouteTemplate.fetchData = async (_, match, urlObj) => {
  const {
    params: { routeCarTypeId }
  } = match;
  const url = `${DATA_LOADER_URL}/api/routeCarTypeTemplateData/${routeCarTypeId}?${urlObj.query}`;
  let responseData;
  const response = await fetch(url);
  const textResponse = await response.text();

  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new DataLoaderError(
      `Unable to fetch city details of ${routeCarTypeId}`,
      responseData.error
    );
  }
  return responseData;
};
export default RouteTemplate;
